import { Component, Input, OnChanges } from '@angular/core';

import { DEFAULT_CURRENCY_CODE } from '@constants/currency';
import { EntrySummaryDutiesModel, EntrySummaryModel, InvoiceModel, LineModel } from '@data-layer/models/entry-summaries';
import { EntrySummaryService } from '@services/entry-summary.service';
import { WEIGHT_UNIT_KG } from '@constants/constants';
import { enumEntrySummaryState } from '@data-layer/enums/entry-summaries';
import { ShipmentModel } from '@data-layer/models/common';
import { take } from 'rxjs/operators';

@Component({
  selector: 'es-details-total',
  templateUrl: './es-details-total.component.html',
  styleUrls: ['./es-details-total.component.scss'],
})
export class EsDetailsTotalComponent implements OnChanges {
  @Input() public entrySummary: EntrySummaryModel;
  @Input() public dutiesValue: EntrySummaryDutiesModel;
  public enteredValue: number;
  public commonGrossWeight: number = 0;
  public DEFAULT_CURRENCY_CODE: string = DEFAULT_CURRENCY_CODE;
  public WEIGHT_UNIT_KG: string = WEIGHT_UNIT_KG;
  public enumEntrySummaryState: typeof enumEntrySummaryState = enumEntrySummaryState;

  constructor(private entrySummaryService: EntrySummaryService) {}

  public ngOnChanges() {
    this.calculateGrossWeight();
    this.entrySummaryService
      .getEntrySummaryEnteredValue(this.entrySummary)
      .pipe(take(1))
      .subscribe((value) => {
        this.enteredValue = value;
      });
  }

  private calculateGrossWeight() {
    this.calcGrossWeight();
  }

  private calcGrossWeight() {
    this.commonGrossWeight = 0;

    this.commonGrossWeight = this.entrySummary ? this.shipmentsWeight(this.entrySummary.shipments) : 0;
  }

  private shipmentsWeight(shipments: ShipmentModel[]): number {
    return shipments && shipments.length ? shipments.reduce((prev, shipment) => prev + this.invoicesWeight(shipment.invoices), 0) : 0;
  }

  private invoicesWeight(invoices: InvoiceModel[]): number {
    return invoices && invoices.length ? invoices.reduce((prev, invoice) => prev + this.linesWeight(invoice.lines), 0) : 0;
  }

  private linesWeight(lines: LineModel[]): number {
    return lines && lines.length ? lines.reduce((prev, line) => prev + line.grossWeight, 0) : 0;
  }
}
